import { gql } from '@apollo/client';

const GET_REWARDS = gql`
  query ($where: StudentRewardsWhereInput!) {
    studentRewards(where: $where) {
      studentId
      student {
        id
        firstName
        lastName
      }
      instructions {
        id
        src
        description
      }
      characterRewards {
        character {
          id
          character
        }
        studentRewards {
          reward {
            audio {
              id
              description
              src
            }
            id
            asset {
              id
              src
              description
            }
          }
          rewardId
          id
          studentId
          characterId
          selected
        }
      }
    }
  }
`;

export default GET_REWARDS;
